// Core/CardPainterInstanceCache.js
// Tracks open card instances managed by CardPainterManager.
// Each instance: { rk: id, registryKey, meta, props }
// id = `${meta.type}:${meta.target}` — one card per (type, target) combination,
// opening the same id again updates instead of duplicating.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'CardPainterInstanceCache';

class CardPainterInstanceCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns all open card instances.
     * @returns {object[]}
     */
    getAll = () => this._items;

    /**
     * Adds or updates a card instance.
     * @param {{ id: string, registryKey: string, meta: object, props: object }} instance
     */
    addCard = (instance) => {
        this.addOrUpdate([{ rk: instance.id, ...instance }]);
    };

    /**
     * Removes a card instance by id.
     * @param {string} id
     */
    removeCard = (id) => {
        this._items = this._items.filter((c) => c.rk !== id);
    };
}

const cardPainterInstanceCache = new CardPainterInstanceCache();
export default cardPainterInstanceCache;
